const INTAKE_DUPLICATE_BADGE_SCOPE = 'intake-duplicate-badge';

export const IntakeDuplicateBadgeTestIds = {
  getBadgeId: segId => `${INTAKE_DUPLICATE_BADGE_SCOPE}.badge-${segId}`,
};
